module.exports = __webpack_public_path__ + "static/media/dice-one.0d23cac3.svg";